(function () {
    let ERPAcceptance = {
        ERPForm: document.querySelector('.ERP-acceptance form'),
        submitBtn: document.querySelector('.ERP-acceptance .agree-submit'),
        checkBoxTandC: document.querySelectorAll('.ERP-acceptance .ERP-TandC'),
        checkboxContainer: document.querySelector('.ERP-acceptance .checkbox--primary'),
        errorContainer: document.querySelector('.ERP-acceptance .checkbox--primary span'),
        errorMsg: document.createElement('p'),

        init: function () {
            ERPAcceptance.control();
        },
        control: function () {
            if (window.location.search.split('redirectUri=').length > 1) {
                let redirectUriValue = ERPAcceptance.findGetParameter();
                let cancelHrefValue = '/action/doLogout?redirectUri=' + redirectUriValue;
                document
                    .querySelector('.ERP-acceptance input[name="redirectUri"]')
                    .setAttribute('value', redirectUriValue);
                document.getElementById('cancelTandC').setAttribute('href', cancelHrefValue);
            }

            ERPAcceptance.submitBtn.addEventListener('click', e => {
                e.preventDefault();
                ERPAcceptance.on.submit();
            });

            ERPAcceptance.checkBoxTandC.forEach(element => {
                element.addEventListener('change', e => {
                    const checkboxContainer = e.target.parentNode;
                    const errorContainer = checkboxContainer.querySelector('span');
                    checkboxContainer.classList.remove('error');
                    errorContainer.classList.remove('error');

                    const removeTermsErrMsg = checkboxContainer.querySelector('.invalid-feedback');

                    if (removeTermsErrMsg) {
                        checkboxContainer.removeChild(checkboxContainer.lastElementChild);
                    }
                });
            });
        },
        on: {
            submit: function () {
                if (
                    document.querySelector('.ERP-TandC:not(.optional , :checked )') === null &&
                    (document.querySelector('.ERP-china') ? document.querySelector('.ERP-china:checked') : true)
                ) {
                    document.querySelector('.ERP-acceptance form').submit();
                } else {
                    const uncheckedBoxes = ERPAcceptance.ERPForm.querySelectorAll(
                        'input[type="checkbox"]:not(:checked , .optional)'
                    );

                    uncheckedBoxes.forEach(checkbox => {
                        const errorMessage = checkbox.parentNode.querySelector('.invalid-feedback');
                        if (!errorMessage) {
                            const errorMsg = document.createElement('p');
                            const checkboxContainer = checkbox.parentNode;
                            errorMsg.classList.add('invalid-feedback');
                            errorMsg.textContent = 'You must accept to continue.';
                            checkboxContainer.querySelector('span').classList.add('error');
                            checkboxContainer.classList.add('error');
                            checkboxContainer.appendChild(errorMsg);
                        }
                    });
                }
            },
        },
        findGetParameter: function () {
            let patt = /[&?]redirectUri=([^&?]+)/i;
            let uri = '/';

            if (patt.test(location.search)) uri = patt.exec(location.search)[1];

            return uri;
        },
    };
    UX.ERPAcceptance = ERPAcceptance;
})();
